import React from 'react'

import { CurrencyIcons } from '@/assets/currency'
import CurrencySelector from '@/atoms/CurrencySelector/CurrencySelector'
import { SizedBox } from '@/atoms/GenericComponents/GenericComponents'
import { Trans, useTranslation } from '@/lib/i18n/i18n'
import { getCurrencySign } from '@/lib/number-utils'

import {
	CurrencyDisclaimer,
	CurrencyIcon,
	CurrencySelectorButton,
	LocaleCurrencySelectorContainer,
	Menu,
	Title,
} from './CurrencySelector.components'
import { useCurrencySelector } from './useCurrencySelector'

export const CurrencySelectorNormal: React.FC = () => {
	const { t } = useTranslation()
	const { companyCurrency, currency, onChange } = useCurrencySelector()
	const [open, setOpen] = React.useState(false)

	const buttonRef = React.createRef<HTMLButtonElement>()
	const menuRef = React.createRef<HTMLDivElement>()

	const currentCurrencyIcon = CurrencyIcons[currency]

	return (
		<LocaleCurrencySelectorContainer data-test="Curency">
			<CurrencySelectorButton
				ref={buttonRef}
				onClick={() => {
					setOpen((open) => !open)
				}}
			>
				{currentCurrencyIcon ? <CurrencyIcon src={currentCurrencyIcon} size={12} /> : getCurrencySign(currency)}
			</CurrencySelectorButton>
			{open && (
				<Menu
					attachTo={{ top: true, right: true }}
					attachOffset={{ y: 50 }}
					onClickOut={(e) => {
						// eslint-disable-next-line @typescript-eslint/no-explicit-any
						const isClickonMenuIcon = (node: any) => buttonRef.current?.contains(node)

						if (!isClickonMenuIcon(e.target)) {
							setOpen(false)
						}
					}}
				>
					<SizedBox ref={menuRef} height={menuRef.current?.offsetHeight}>
						<>
							<Title>{t('locale-selector.select-currency')}</Title>
							<CurrencySelector
								currency={currency}
								onChange={(curr) => {
									onChange(curr)
									setOpen(false)
								}}
							/>
							{!!companyCurrency && (
								<CurrencyDisclaimer>
									<Trans i18nKey="locale-selector.disclaimer">
										<b>Important</b> You'll see prices in the selected currency, but the invoice will be charged in
										{{ currency: companyCurrency }}.
									</Trans>
								</CurrencyDisclaimer>
							)}
						</>
					</SizedBox>
				</Menu>
			)}
		</LocaleCurrencySelectorContainer>
	)
}
